<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title" style="display: flex;align-items: center;">
					ព័ត៌មានអំពីកញ្ចប់ឥវ៉ាន់
					<router-link :to="'/packages/edit/' + package.hash_id" v-if="package.package_status != 'dlv'">
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>edit</md-icon>
							<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
						</md-button>
					</router-link>
				</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-40">
				<table style="border-width: 0px; line-height: 32px;">
					<tr>
						<td style="width: 150px">លេខកូដកញ្ចប់</td>
						<td style="width: 40px">៖</td>
						<td>{{package.tracking}}</td>
					</tr>
					<tr>
						<td>ប្រភេទកញ្ចប់</td>
						<td>៖</td>
						<td>{{package.package_type}}</td>
					</tr>
					<tr>
						<td>ទីតាំង</td>
						<td>៖</td>
						<td>{{package.location}}</td>
					</tr>
					<tr>
						<td>អ្នកទទួល</td>
						<td>៖</td>
						<td>{{package.receiver_phone}}</td>
					</tr>
					<tr>
						<td>តម្លៃឥវ៉ាន់</td>
						<td>៖</td>
						<td><b>{{config.moneylify(package.price, package.price_currency)}}
								<span v-if="package.price == 0">(ទូទាត់រួច)</span>
								<span v-if="package.price > 0">(មិនទាន់ទូទាត់)</span>
							</b></td>
					</tr>
					<tr>
						<td>ថ្លៃដឹកជញ្ជូន</td>
						<td>៖</td>
						<td><b>{{config.moneylify(package.fee, package.fee_currency)}}
								({{config.getStatus(package.fee_responsible)}})</b></td>
					</tr>
					<tr>
						<td>ស្ថានភាព</td>
						<td>៖</td>
						<td>
							<span class="error" v-if="package.package_status == 'ndv'">{{
								config.getStatus(package.package_status) }}</span>
							<span class="late" v-if="package.package_status == 'wdv'">{{
								config.getStatus(package.package_status) }}</span>
							<span class="neutral" v-if="package.package_status == 'dvr'">{{
								config.getStatus(package.package_status) }}</span>
							<span class="green" v-if="package.package_status == 'dlv'">{{
								config.getStatus(package.package_status) }}</span>
							<span class="return" v-if="package.package_status == 'rtn'">{{
								config.getStatus(package.package_status) }}</span>
						</td>
					</tr>
					<tr>
						<td>បានបញ្ចូលដោយ</td>
						<td>៖</td>
						<td>{{package.created_by}}</td>
					</tr>
					<tr>
						<td>បានបញ្ជាក់ទូទាត់រួចដោយ</td>
						<td>៖</td>
						<td>{{package.paid_by}}</td>
					</tr>
					<tr>
						<td>បានត្រឡប់ដោយ</td>
						<td>៖</td>
						<td>{{package.returned_by}}</td>
					</tr>

				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-40">
				<table style="border-width: 0px; line-height: 32px;">

					<tr>
						<td style="width: 150px">ឈ្មោះអតិថិជន</td>
						<td style="width:40px">៖</td>
						<td>{{package.client_name}}</td>
					</tr>
					<tr>
						<td>លេខទូរស័ព្ទ</td>
						<td>៖</td>
						<td>{{package.client_phone}}</td>
					</tr>
					<tr>
						<td>ចំណាំអតិថិជន</td>
						<td>៖</td>
						<td>{{package.client_note}}</td>
					</tr>
					<tr>
						<td>អ្នកដឹកជញ្ជូន</td>
						<td>៖</td>
						<td>{{package.driver_name}}</td>
					</tr>
					<tr>
						<td>លេខទូរស័ព្ទ</td>
						<td>៖</td>
						<td>{{package.driver_phone}}</td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20" style="display: flex; flex-direction: column; align-items: center;">
				<span style="margin-bottom: 8px">QR កូដកញ្ចប់ឥវ៉ាន់</span>
				<qr-code :text="'admin-'+package.hash_id" :size="300" style="width: 100%; max-width: 150px;"></qr-code>
				<!-- <span style="margin-bottom: 8px">QR កូដកញ្ចប់ឥវ៉ាន់ចាស់</span>
				<qr-code :text="'admin-'+package.hash_id" :size="300" style="width: 100%; max-width: 150px;"></qr-code> -->
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">កំណត់ចំណាំរបស់កញ្ចប់ឥវ៉ាន់</h3>
				<p v-if="String(package.package_note).length > 0">{{package.package_note}}</p>
				<p v-else>មិនមាន</p>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">កែប្រែកំណត់ចំណាំរបស់កញ្ចប់ឥវ៉ាន់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25">
				<md-field>
					<label>ជ្រើសរើសស្ថានភាពកញ្ចប់ឥវ៉ាន់</label>
					<md-select placeholder="ជ្រើសរើសស្ថានភាពកញ្ចប់ឥវ៉ាន់" v-model="note">
						<md-option value="មិនមាន">មិនមាន</md-option>
						<md-option value="ទាក់ទងមិនបាន">ទាក់ទងមិនបាន</md-option>
						<md-option value="យកថ្ងៃស្អែក">យកថ្ងៃស្អែក</md-option>
						<md-option value="ប្តូរទីតាំង">ប្តូរទីតាំង</md-option>
						<md-option value="អីវ៉ាន់ខុស">អីវ៉ាន់ខុស</md-option>
					</md-select>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-70 md-size-25">
				<md-field>
					<label>កំណត់ចំណាំថ្មី</label>
					<md-input type="text" v-model="note"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-30  md-size-20">
				<md-button class="md-raised md-success" @click="updateNote()">រក្សាទុក</md-button>
			</div>

			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-danger" @click="returnPackage(package.hash_id)"
					v-if="package.package_status != 'dlv' && package.package_status != 'rtn'">
					ត្រឡប់កញ្ចប់ឥវ៉ាន់</md-button>
					<md-button class="md-raised md-primary" @click="payPayment(package.hash_id)" v-if="package.price > 0 && package.package_status != 'dlv' && package.package_status != 'rtn'">
						បញ្ជាក់ថាកញ្ចប់ឥវ៉ាន់បានទូទាត់រួច</md-button>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="payDialog" md-title="តើអ្នកពិតជាចង់ដាក់កញ្ចប់ឥវ៉ាន់នេះថាទូទាត់រួចឬ?"
			md-content="" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="payPayment" />
		<md-dialog-confirm :md-active.sync="returnDialog" md-title="តើអ្នកពិតជាចង់ត្រឡប់កញ្ចប់ឥវ៉ាន់នេះមែនឬ?"
			md-content="" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="returnPackage" />
	</div>
</template>
<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent,
		},
		created() {
			this.getPackage();
			// this.getPayment();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				payDialog: false,
				returnDialog: false,
				payID: "",
				returnID: "",
				package: {
					id: "",
					hash_id: "",
					tracking: "",
					client_name: "",
					client_phone: "",
					client_note: "",
					location: "",
					receiver_phone: "",
					package_status: "",
					driver_note: "",
					package_note: "",
					driver_name: "",
					driver_phone: "",
					note: "",
					fee_responsible: ""
				},
				note: ""
			}
		},
		methods: {
			getPackage(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/package/get/" + this.$route.params.hash_id).then(data => {
					this.package = data.body.data
					// console.log(data.body.data)
					this.loaded = true
				})
			},
			payPayment(id = "") {
				if (id == "" && String(this.payID).length > 0) {
					this.$http.post(this.config.api + "/admin/package/pay/payment", {
						package_hash_id: this.package.hash_id
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "កញ្ចប់ឥវ៉ាន់បានដាក់ទូទាត់ដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getPackage();
							this.onCancel();
						}
					})
				} else {
					this.payID = id;
					this.payDialog = true;
				}

			},
			returnPackage(id = "") {
				if (id == "" && String(this.returnID).length > 0) {
					this.$http.post(this.config.api + "/admin/package/return", {
						package_hash_id: this.package.hash_id
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "កញ្ចប់ឥវ៉ាន់ត្រឡប់ដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getPackage();
							this.onCancel();
						}
					})
				} else {
					this.returnID = id;
					this.returnDialog = true;
				}

			},
			markPaid() {

			},
			updateNote() {
				this.$http.post(this.config.api + "/admin/package/note", {
						package_hash_id: this.package.hash_id,
						package_note: this.note
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "កញ្ចប់ឥវ៉ាន់ត្រូវបានកែប្រែកំណត់ចំណាំដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getPackage();
							this.onCancel();
						}
					})
			},
			onCancel() {
				this.payDialog = false;
				this.payID = "";
				this.returnDialog = false;
				this.returnID = "";
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Packages/Detail.vue